import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Navigation } from "./components/Navigation";
import { Header } from "./components/Header";
import { About } from "./components/About";
import { Services } from "./components/Services";
import { Portfolio } from "./components/Portfolio";
import { Reviews } from "./components/Reviews";
import { Contacts } from "./components/Contacts";
import { Footer } from "./components/Footer";
import { Modal337 } from "./components/Modal337";
import ScrollToTopButton from "./components/Scroll2top";
import JsonData from "./data/data.json";
import "./css/index.scss";
import { scrollToSection } from "./utils/scrollToSection";
import SEO from "./components/SEO";
import seoData from "./data/seoData";
import { HelmetProvider } from "react-helmet-async";
import { schemaData, ogData, twitterData } from "./data/seoSchema";
import { portfolioSchema } from "./data/portfolioSchema";
import metalRestorationSchema from "./data/metalRestorationSchema";
import useSectionManager from "./hooks/useSectionManager";
import NotFound from "./components/NotFound";
// import Intersection from "./components/Intersection-o-api";

// Main page with sections
const MainPage = ({ landingPageData, handleOpenModal }) => (
  <>
    <section>
      <Header data={landingPageData.Header} />
    </section>
    <section id="about-us">
      <About data={landingPageData.About} />
    </section>
    <section id="metal-restoration-services">
      <Services data={landingPageData.Services} onOpenModal={handleOpenModal} />
    </section>
    <section id="restoration-portfolio">
      <Portfolio data={landingPageData.Portfolio} />
    </section>
    <section id="customer-reviews">
      <Reviews data={landingPageData} />
    </section>
    <section id="contacts">
      <Contacts data={landingPageData.Contacts} />
    </section>
  </>
);

// Use data from seoData
const ScrollHandler = ({ landingPageData, handleOpenModal }) => {
  const { pathname } = useLocation();
  const currentSection = useSectionManager(); // Get current section from hook
  const currentSEO = seoData[currentSection] || seoData[""]; // Use data for empty string as fallback

  // Set canonical URL using baseUrl from data.json
  const canonicalUrl =
    currentSection === ""
      ? JsonData.baseUrl
      : `${JsonData.baseUrl}/${currentSection}`;

  // Select schema.org data depending on the page
  const currentSchema = {
    "/metal-restoration-services": metalRestorationSchema,
    "/restoration-portfolio": portfolioSchema,
  }[currentSection] || schemaData;

// For precise scrolling when opening a new tab with a slug or when refreshing the page
  useEffect(() => {
    const section = pathname.slice(1); // Remove the slash
    const validSections = ["about-us", "metal-restoration-services", "restoration-portfolio", "customer-reviews", "contacts"];

    if (validSections.includes(section)) {
      scrollToSection(section); // Scroll to the required section
    // } else if (pathname !== "/") {
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to top if no valid section is found
    }
  }, [pathname]);

  // Check if such section exists
  // if (pathname !== "/" && !seoData[pathname.slice(1)] && pathname !== "/404") {
  if (pathname !== "/" && !seoData[pathname.slice(1)]) {
    return <NotFound />;
  }

  return (
    <>
      <SEO
        title={currentSEO.title}
        description={currentSEO.description}
        schemaData={currentSchema}
        ogData={ogData}
        twitterData={twitterData}
        canonicalUrl={canonicalUrl}
      />
      <MainPage landingPageData={landingPageData} handleOpenModal={handleOpenModal} />
    </>
  );
};

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  const [modalData, setModalData] = useState({
    show: false,
    title: "",
    text: "",
    desc: "",
    img: "",
    alt: "",
    price: "",
  });

  // Load data on mount
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  // Open modal window
  const handleOpenModal = (name, text, desc, img, alt, price) => {
    setModalData({ show: true, title: name, text, desc, img, alt, price });
  };

  // Close modal window
  const handleCloseModal = () => {
    setModalData({ ...modalData, show: false });
  };

  return (
    <HelmetProvider>
      <BrowserRouter>
        <div>
          <Navigation />
          <Routes>
            <Route
              path="/*"
              element={<ScrollHandler landingPageData={landingPageData} handleOpenModal={handleOpenModal} />}
            />
            {/* <Route path="*" element={<NotFound />} /> */}
          </Routes>
          <Footer />
          <Modal337
            show={modalData.show}
            title={modalData.title}
            text={modalData.text}
            desc={modalData.desc}
            img={modalData.img}
            alt={modalData.alt}
            price={modalData.price}
            onClose={handleCloseModal}
          />
          <ScrollToTopButton />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
};

export default App;
